/**
 * SiteLayout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql, Link } from "gatsby"

import Header from "./header"
import Footer from "./footer"
import "./layout.css"
import 'antd/dist/antd.css';
//import '../css/antd.css';
import "../css/accordions.css"
import "../css/search.css"
import "../css/uniqueToThisSite.css"
import "../css/SortedEditor.css"

const SiteLayout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteQuery {

        site {
          siteMetadata {
            title
          }
        }

        allPage {

          nodes {
            heading
            content
            featured_image {
              fileName
              extension
            }
            id
            name
            slug
          }

        }


        home {

          heading
          content
          featured_image {
            fileName
            extension
          }

        }

    }
    `}
    render={data => (
      <>
        <Header siteTitle={data.site.siteMetadata.title} />
        <div className="main-wrap">
          <Link to="/" className="btn home-btn">Home</Link>
          <Link to="/news" className="btn home-btn news-archive-btn">News</Link>
          <main>{children}</main>
        </div>
        <Footer />
      </>
    )}
  />
)

SiteLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default SiteLayout
